import AdminPaymentHistory from "../components/AdminPaymentHistory";
import useAdminPaymentHistory from "../hooks/useAdminPaymentHistory";

const AdminPaymentHistoryPage = () => {
    const useAdminPaymentHistoryProps = useAdminPaymentHistory();

    return (
        <AdminPaymentHistory {...useAdminPaymentHistoryProps} />
    )
}

export default AdminPaymentHistoryPage;